import React from 'react';
import './EventCard.css';

const EventCard = ({ event, onEventClick }) => {
  // 여러 장르를 처리하기 위한 유틸리티 함수들
  const parseGenres = (genreString) => {
    if (!genreString) return [];
    return genreString.split(',').map(genre => genre.trim().toLowerCase()).filter(genre => genre);
  };

  const getPrimaryGenre = (genreString) => {
    const genres = parseGenres(genreString);
    return genres.length > 0 ? genres[0] : '';
  };

  const getValidGenres = (genreString) => {
    const validGenres = ['edm', 'hiphop', 'techno', 'house'];
    const genres = parseGenres(genreString);
    return genres.filter(genre => validGenres.includes(genre));
  };

  // 장르별 색상 매핑 (EventCalendar와 동일)
  const getGenreColor = (genre) => {
    const colorMap = {
      'edm': '#22c55e',
      'hiphop': '#eab308', 
      'techno': '#3b82f6',
      'house': '#ec4899'
    };
    return colorMap[genre] || '#666';
  };

  const handleClick = () => {
    if (onEventClick) {
      onEventClick(event);
    }
  };

  return (
    <div className={`event-card ${getPrimaryGenre(event.genre)}`} onClick={handleClick}>
      <div className="event-card-info">
        <span className="event-card-date">{new Date(event.date || event.event_date).getDate()}일</span>
        <h4 className="event-card-title">{event.title}</h4>
        <p className="event-card-location">
          {event.club && event.club.name ? event.club.name : (event.location || '장소 미정')}
        </p>
        <div className="event-card-genre-tags">
          {getValidGenres(event.genre).map((genre, index) => (
            <span key={`${event.id}-genre-${index}`} className={`event-card-genre-tag genre-${genre}`}>
              {genre.toUpperCase()}
            </span>
          ))}
        </div>
      </div>
      {event.poster_image_url && (
        <div className="event-card-poster">
          <img src={event.poster_image_url} alt={event.title} />
        </div>
      )}
    </div>
  );
};

export default EventCard; 